import { accountsMock } from "./accountsMock";

export const MOCK_PAGES = {
  accounts: accountsMock,
};
